<div class="okta-callback">
  @if (completing()) {
    <p class="okta-callback__status" role="status">Completing Okta login…</p>
  }

  @if (errorMessage(); as message) {
    <p class="okta-callback__error" role="alert">{{ message }}</p>
    <a class="okta-callback__link" routerLink="/login">Back to login</a>
  }
</div>
